import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import {
  ResourceServiceProxy,
  ResourceListDto,
  FormRenderServiceProxy,
  ManageDirectoryServiceProxy,
  ResourceCreateOrUpdateDto,
  FileInfoVO,
  ManageDirectoryDto,
} from '@/service-proxies/app-v2/dnc.service-proxies'
const rsp = new ResourceServiceProxy()
const frsp = new FormRenderServiceProxy()
const mdsp = new ManageDirectoryServiceProxy()
import ResourceTable from './components/ResourceTable'
import CreateForm from './components/CreateForm'
import UpdateForm from './components/UpdateForm'
import VersionTable from './components/VersionTable'
import ComparePanel from './components/ComparePanel'
import SearchForm from './components/SearchForm'
const CODE = 'DNC_RESOURCE'

import './index.less'
import { Modal } from 'ant-design-vue'

@Component({
  components: {
    ResourceTable,
    CreateForm,
    UpdateForm,
    VersionTable,
    ComparePanel,
    SearchForm,
  },
})
export default class ResourcePool extends Vue {
  @Ref() createForm: CreateForm
  @Ref() updateForm: UpdateForm
  @Ref() searchForm: SearchForm
  @Ref() resourceTable: ResourceTable
  tableColumns: any[] = []
  treeProps = {
    // treeData: [] as ManageDirectoryTreeDto[],
    treeData: [],
    replaceFields: {
      key: 'id',
    },
    showLine: true,
  }
  treeEvents = {
    select: this.onTreeSelect,
    // rightClick: ({ event, node }) => {
    //   console.log(event, node)
    // }
  }
  treeLoading = false
  currentId: any = undefined
  currentRecord: any = { id: '' }
  visible = {
    history: false,
    search: false,
  }
  loading = {
    search: false,
    history: false,
  }
  versionList = []
  versionFileList = []
  currentVersion: any = {}
  currentVersionIndex: any = 0
  canDelete = false
  currentTreeNodeId = ''
  newTreeNodeName = ''

  searchVisible = false
  tableData: ResourceListDto[] = []
  tableLoading = false
  modalLoading = false
  modalVisible = false
  drawerVisible = false
  drawerLoading = false

  get isPublished() {
    return this.currentRecord.state === 'PUBLISHED'
  }
  get isDrafted() {
    return this.currentRecord.state === 'DRAFTED'
  }

  get canCreate() {
    // return true
    return this.treeProps.treeData.length
  }

  @Watch('treeLoading')
  clickFirstNode() {
    this.$nextTick(() => {
      const firstTreeNode: any = document.querySelector('.ant-tree-title')
      if (firstTreeNode) {
        firstTreeNode.click()
      }
    })
  }

  created() {
    this.loadTreeData()
  }

  async onTreeSelect(keys) {
    this.currentId = keys[0]
    await this.loadTableData()
  }

  async loadTreeData() {
    function helper(arr) {
      return arr.map(item => ({
        ...item,
        scopedSlots: { title: 'customNode' },
        children: helper(item.children),
        style: { width: '100%' },
      }))
    }
    this.treeLoading = true
    const res = await mdsp.treeList(0)
    // debugger
    this.treeProps.treeData = helper(res)
    // debugger
    this.treeLoading = false
  }

  async loadTableData(filter = {}) {
    if (!this.currentId) {
      this.tableColumns = []
      this.tableData = []
      return
    }
    try {
      this.tableLoading = true
      const res = await Promise.all([frsp.findAllTableColumnList(CODE), rsp.list(this.currentId, filter)])
      this.tableColumns = res[0].map(item => ({ title: item.title, dataIndex: item.code, widget: item.widget }))
      // this.tableData = res[1]

      let dataLength = res[1].length;
      let copy = JSON.parse(JSON.stringify(res[1]));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {
            // id: 'none'
          }
          copy.push(obj)
        }
      }

      this.tableData = JSON.parse(JSON.stringify(copy));
      console.log(this.tableData,'xxxxxx')

      this.tableLoading = false
    } catch (e) {
      console.log(e.message)
      this.tableLoading = false
    }
  }

  handleCreate() {
    // 1 加工程序 2 工艺文件
    const { form } = this.createForm.dForm
    const { programs: p, documents: d } = this.createForm
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.modalLoading = true
          const programs = p.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 1,
            } as FileInfoVO
          })
          const documents = d.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 2,
            } as FileInfoVO
          })
          const resource = {
            ...values,
            documentDirectory: this.currentId,
          }
          const body = {
            files: [...programs, ...documents] as FileInfoVO[],
            resource: resource,
          } as ResourceCreateOrUpdateDto
          await rsp.create(body)
          this.modalLoading = false
          this.modalVisible = false
          this.$message.success(this.$t('page_resource_pool_success'))
          await this.loadTableData()
        } catch (e) {
          console.log(e.message)
          this.modalLoading = false
        }
      }
    })
  }

  handleCreatePublish() {
    // 1 加工程序 2 工艺文件
    const { form } = this.createForm.dForm
    const { programs: p, documents: d } = this.createForm
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.modalLoading = true
          const programs = p.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 1,
            } as FileInfoVO
          })
          const documents = d.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 2,
            } as FileInfoVO
          })
          const resource = {
            ...values,
            documentDirectory: this.currentId,
          }
          const body = {
            files: [...programs, ...documents] as FileInfoVO[],
            resource: resource,
          } as ResourceCreateOrUpdateDto
          await rsp.createAndPublish(body)
          //const resourceId = await rsp.create(body)
          //await rsp.publish(resourceId)
          this.modalLoading = false
          this.modalVisible = false
          this.$message.success(this.$t('page_resource_pool_success'))
          await this.loadTableData()
        } catch (e) {
          console.log(e.message)
          this.modalLoading = false
        }
      }
    })
  }

  async handleDelete(id = -1) {
    if (id === -1) {
      const { selectedIds } = this.resourceTable
      const ids = selectedIds.join(',')
      await rsp.delete(ids)
    } else {
      await rsp.delete('' + id)
    }
    await this.loadTableData()
  }

  async handleUpdate() {
    const { form } = this.updateForm.dForm
    const { fakeRecord } = this.updateForm
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.drawerLoading = true
          const programs = fakeRecord.programs.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 1,
            } as FileInfoVO
          })
          const documents = fakeRecord.documents.map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              displayName: item.displayName,
              objectKey: item.objectKey,
              suffix: item.suffix,
              fileType: 2,
            } as FileInfoVO
          })
          const resource = {
            ...values,
            documentDirectory: this.currentId,
          }
          const body: any = {
            files: [...programs, ...documents] as FileInfoVO[],
            resource: resource,
          }
          await rsp.update(this.currentRecord.id, body)
          this.drawerLoading = false
          this.drawerVisible = false
          this.$message.success(this.$t('page_resource_pool_success'))
          await this.loadTableData()
        } catch (e) {
          console.log(e.message)
          this.drawerLoading = false
        }
      }
    })
  }

  async handleUse(id) {
    this.loading.history = true
    await rsp.switchVersion(this.currentRecord.id, id)
    await this.loadVersionTable()
    this.loading.history = false
  }

  async handlePublish() {
    try {
      if (!this.isPublished && !this.isDrafted) {
        const { form } = this.updateForm.dForm
        const { fakeRecord } = this.updateForm
        form.validateFields(async (err, values) => {
          if (!err) {
            try {
              this.drawerLoading = true
              const programs = fakeRecord.programs.map(item => {
                return {
                  contentLength: item.contentLength,
                  contentMd5: item.contentMd5,
                  contentType: item.contentType,
                  displayName: item.displayName,
                  objectKey: item.objectKey,
                  suffix: item.suffix,
                  fileType: 1,
                } as FileInfoVO
              })
              const documents = fakeRecord.documents.map(item => {
                return {
                  contentLength: item.contentLength,
                  contentMd5: item.contentMd5,
                  contentType: item.contentType,
                  displayName: item.displayName,
                  objectKey: item.objectKey,
                  suffix: item.suffix,
                  fileType: 2,
                } as FileInfoVO
              })
              const resource = {
                ...values,
                documentDirectory: this.currentId,
              }
              const body = {
                files: [...programs, ...documents] as FileInfoVO[],
                resource: resource,
              } as ResourceCreateOrUpdateDto
              await rsp.update(this.currentRecord.id, body)
              await rsp.publish(this.currentRecord.id)
              this.drawerLoading = false
              this.drawerVisible = false
              this.$message.success(this.$t('page_resource_pool_success'))
              await this.loadTableData()
            } catch (e) {
              console.log(e.message)
              this.drawerLoading = false
            }
          }
        })
      } else {
        this.drawerLoading = true
        await rsp.publish(this.currentRecord.id)
        this.drawerLoading = false
        this.drawerVisible = false
        await this.loadTableData()
      }
    } catch (e) {
      console.log(e.message)
      this.drawerLoading = false
    }
  }

  async onAct(action) {
    if (action.type === 'edit') {
      if (this.drawerVisible) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: async () => {
            this.currentRecord = action.payload
            await this.updateCurrentRecord()
            this.drawerVisible = true
            this.searchVisible = false
          },
          onCancel() {
            return
          },
        })
      } else {
        this.currentRecord = action.payload
        await this.updateCurrentRecord()
        this.drawerVisible = true
        this.searchVisible = false
      }
    }
    if (action.type === 'delete') {
      this.handleDelete(action.payload.id)
    }
  }

  async updateCurrentRecord() {
    const fileTableData = await rsp.resourceFileList(this.currentRecord.id)
    this.currentRecord = {
      ...this.currentRecord,
      programs: fileTableData.filter(item => item.fileType === 1),
      documents: fileTableData.filter(item => item.fileType === 2),
    }
  }

  async showHistory() {
    await this.loadVersionTable()
    this.visible.history = true
  }

  async loadVersionTable() {
    const res = await rsp.versionList(this.currentRecord.id)
    this.versionList = res
    this.versionFileList = []
    for (let version of this.versionList) {
      const res = await rsp.versionFileList(version.id)
      this.versionFileList.push({
        ...version,
        files: res,
      })
    }
  }

  handleSelect({ record, index }) {
    this.currentVersion = record
    this.currentVersionIndex = index
  }

  handleSearch() {
    const { form } = this.searchForm.dForm
    form.validateFields(async (err, values) => {
      for (let key in values) {
        if (Array.isArray(values[key]) && values[key].length === 2) {
          if (values[key][0] === null || values[key][1] === null) {
            values[key] = void 0
          }
        }
      }
      if (!err) {
        try {
          this.loading.search = true
          await this.loadTableData(values)
          this.loading.search = false
          this.visible.search = false
        } catch (e) {
          console.log(e.message)
          this.loading.search = false
        }
      }
    })
  }

  afterReplace() {
    this.drawerVisible = false
    this.loadTableData()
  }

  onTreeRightClick(e) {
    this.currentTreeNodeId = e.node.eventKey
  }
  // 显示隐藏高级搜索
  showSearch(){
    this.drawerVisible = false
    this.searchVisible = !this.searchVisible
  }
  // 高级搜索重置
  searchReset(){
    const { form } = this.searchForm.dForm;
    form.resetFields();
  }
  handleTreeNode({ key }, context) {
    if (key === '1') {
      this.handleTreeNodeCreate(context)
    } else if (key === '2') {
      this.handleTreeNodeRename(context)
    } else if (key === '3') {
      this.handleTreeNodeDelete(context)
    }
  }

  async handleTreeNodeCreate(context) {
    this.newTreeNodeName = ''
    Modal.confirm({
      icon: () => null,
      title: null,
      content: () => (
        <a-form-item label="子目录名" labelCol={{ span: 5 }} wrapperCol={{ span: 17 }}>
          <a-input v-model={this.newTreeNodeName} placeholder="请输入子目录名" />
        </a-form-item>
      ),
      okText: '提交',
      onOk: async () => {
        if (!this.newTreeNodeName) {
          this.$message.error('目录名不可为空')
          return Promise.reject()
        }
        if (this.newTreeNodeName.length > 100) {
          this.$message.error('最大长度为100')
          return Promise.reject()
        }
        await mdsp.save({
          isSetting: 0,
          name: this.newTreeNodeName,
          parentAllPath: context.data.allPath,
          parentId: context.id,
        } as ManageDirectoryDto)
        this.newTreeNodeName = ''
        await this.loadTreeData()
      },
      maskClosable: true,
    })
  }

  handleTreeNodeRename(context) {
    this.newTreeNodeName = context.title
    Modal.confirm({
      icon: () => null,
      content: () => (
        <a-form-item label="目录名" labelCol={{ span: 5 }} wrapperCol={{ span: 17 }}>
          <a-input v-model={this.newTreeNodeName} placeholder="请输入目录名" />
        </a-form-item>
      ),
      okText: '提交',
      onOk: async () => {
        if (!this.newTreeNodeName) {
          this.$message.error('目录名不可为空')
          return Promise.reject()
        }
        if (this.newTreeNodeName.length > 100) {
          this.$message.error('最大长度为100')
          return Promise.reject()
        }
        await mdsp.update({
          isSetting: 0,
          name: this.newTreeNodeName,
          parentAllPath: context.data.allPath
            .split('/')
            .slice(0, -1)
            .join('/'),
          parentId: context.parentId,
          id: context.id,
        } as ManageDirectoryDto)
        this.newTreeNodeName = ''
        await this.loadTreeData()
      },
      maskClosable: true,
    })
  }

  handleTreeNodeDelete(context) {
    Modal.confirm({
      content: '确定要删除吗？',
      onOk: async () => {
        await mdsp.delete(context.id)
        await this.loadTreeData()
      },
      maskClosable: true,
    })
  }

  render() {
    console.log('this.treeProps.treeData',this.treeProps.treeData)
    return (
      <div class="resource-pool" style="display: flex; height: 100%;">
        <div
          style={{
            position: 'relative',
            flex: 'none',
            width: '296px',
            height: '100%',
            backgroundColor: '#ffffff',
            boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.1)',
            borderRadius: '2px',
            padding: '8px',
          }}
        >
          {this.treeLoading ? (
            <a-spin
              size="large"
              spinning={true}
              style={{ position: 'absolute', top: '320px', left: '50%', transform: 'translateX(-50%)' }}
            />
          ) : (
            <a-tree
              treeData={this.treeProps.treeData}
              replaceFields={this.treeProps.replaceFields}
              showIcon
              defaultExpandAll
              onSelect={this.onTreeSelect}
              onRightClick={this.onTreeRightClick}
              blockNode
              scopedSlots={{

                customNode: context => (
                  <div style="display: flex; align-items: center">
                    <ellipsis length={16} tooltip={true}>
                      {context.title}
                    </ellipsis>
                    {context.id === this.currentId ? (
                      <a-dropdown trigger={['hover']}>
                        <a-icon type="down" style="font-size: 10px; margin-left: auto; width: 40px;" />
                        <a-menu slot="overlay" onClick={e => this.handleTreeNode(e, context)}>
                          <a-menu-item key="1">{this.$t('create_subdirectory')}</a-menu-item>
                          <a-menu-item key="2" disabled={context.data.isSetting === 1}>
                            {this.$t('page_role_management_rename')}
                          </a-menu-item>
                          <a-menu-item key="3" disabled={context.data.isSetting === 1}>
                            {this.$t('delete')}
                          </a-menu-item>
                        </a-menu>
                      </a-dropdown>
                    ) : null}


                    {context.expanded ?
                      (context.children && context.children.length > 0 ?
                        <a-icon  type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;'/>
                        :
                        null
                      )
                      :
                      (context.children && context.children.length > 0 ?
                        <a-icon  type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;'/>
                        :
                        null
                      )
                    }

                  </div>
                ),
              }}
            />
          )}
        </div>
        <div v-resize={'x'}></div>
        <blank-view
          bodyStyle={{ padding: 0, position: 'relative', overflow: 'hidden' }}
          style="width: calc(100% - 312px)"
        >
          <template slot="action">
            <a-button
              v-acl={'page_resource_pool_create'}
              type="primary"
              disabled={!this.currentId}
              onClick={e => (this.canCreate ? (this.modalVisible = true) : e.preventDefault())}
            >
              {this.$t('page_package_add')}
            </a-button>
            {/* <a-dropdown>
              <a-menu slot="overlay" onClick={this.clickMoreActions}>
                <a-menu-item key="1">下载</a-menu-item>
                <a-menu-item key="2">移动</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                更多操作
                <a-icon type="down" />
              </a-button>
            </a-dropdown> */}
            {this.canDelete ? (
              <a-popconfirm
                title={this.$t('page_resource_pool_confirm_delete')}
                onConfirm={() => (this.canDelete ? this.handleDelete(-1) : void 0)}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
                <a-button v-acl={'page_resource_pool_delete'} type="danger" style="margin-left: 8px;">
                  {this.$t('delete')}
                </a-button>
              </a-popconfirm>
            ) : (
              <a-button disabled={true} v-acl={'page_resource_pool_delete'} type="danger" style="margin-left: 8px;">
                {this.$t('delete')}
              </a-button>
            )}

            <a-button
              disabled={!this.currentId}
              style={{ float:'right' }}
              icon="filter"
              onClick={() => {this.showSearch()}}
            >
              {this.$t('page_my_document_advanced')}
            </a-button>
          </template>
          <ResourceTable
            ref="resourceTable"
            columns={this.tableColumns}
            data={this.tableData}
            onAct={this.onAct}
            loading={this.tableLoading}
            onSelect={bool => (this.canDelete = bool)}
          />
          {/* 高级搜索 */}
          <dragModal
            title={this.$t('page_my_document_advanced')}
            subTitle={'('+this.$t('page_transport_directory_resource_bundle')+')'}
            top="122px"
            width="540px"
            visible={this.searchVisible}
            onClose={() => {this.searchVisible = false}}
          >
            <SearchForm ref="searchForm" />
            <div style="text-align:center;" slot="footer">
              <a-button type="primary" onClick={this.handleSearch.bind(this, true)}>
                {this.$t('common_search')}
              </a-button>
              <a-button type="default" style="margin-left:10px;" onClick={() => {this.searchReset()}}>
                {this.$t('common_reset')}
              </a-button>
            </div>
          </dragModal>

          <a-modal
            title={this.drawerVisible ? this.$t('edit') : this.$t('page_my_document_advanced')}
            closable={true}
            onCancel={() => {
              this.drawerVisible = false
              this.searchVisible = false
            }}
            visible={this.drawerVisible}
            width={800}
            mask={false}
          >
            {this.drawerVisible ? (
              <div>
                <UpdateForm
                  ref="updateForm"
                  record={this.currentRecord}
                  onRefresh={this.updateCurrentRecord}
                  onClose={this.afterReplace}
                  onRefreshTableData={this.loadTableData}
                  onUpdate={bool => (this.drawerLoading = bool)}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e8e8e8',
                    padding: '10px 16px',
                    textAlign: 'right',
                    left: 0,
                    background: '#fff',
                    borderRadius: '0 0 4px 4px',
                    zIndex: '100',
                  }}
                >
                  {this.isPublished || this.isDrafted ? (
                    <a-button style="margin-right: 16px;" loading={this.drawerLoading} onClick={this.showHistory}>
                      {this.$t('page_resource_pool_history')}
                    </a-button>
                  ) : (
                    ''
                  )}
                  {this.isPublished || this.isDrafted ? (
                    ''
                  ) : (
                    <a-button style="margin-right: 16px;" loading={this.drawerLoading} onClick={this.handleUpdate}>
                      {this.$t('save')}
                    </a-button>
                  )}
                  <a-button type="primary" loading={this.drawerLoading} onClick={this.handlePublish}>
                    {this.$t('page_resource_pool_publish')}
                  </a-button>
                </div>
              </div>
            ) : null}
            {/* {this.searchVisible ? (
              <div>
                <SearchForm ref="searchForm" />
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e8e8e8',
                    padding: '10px 16px',
                    textAlign: 'right',
                    left: 0,
                    background: '#fff',
                    borderRadius: '0 0 4px 4px',
                    zIndex: '100',
                  }}
                >
                  <a-button type="primary" loading={this.loading.search} onClick={this.handleSearch.bind(this, true)}>
                    {this.$t('search')}
                  </a-button>
                </div>
              </div>
            ) : null} */}
          </a-modal>
          {/* 新增资源的弹出框 */}
          <a-modal
            title={this.$t('page_package_add')}
            v-model={this.modalVisible}
            //onOk={this.handleCreate}
            confirmLoading={this.modalLoading}
            //okText={this.$t('submit')}
            //cancelText={this.$t('cancel')}
            destroyOnClose={true}
            maskClosable={false}
            width={800}
          >
            <div slot="footer">
              <a-button onClick={() => (this.modalVisible = false)}>{this.$t('cancel')}</a-button>
              <a-button style="background: #52c41a; color: #fff" onClick={this.handleCreatePublish}>
                {this.$t('page_resource_pool_publish')}
              </a-button>
              <a-button type="primary" onClick={this.handleCreate}>
                {this.$t('save')}
              </a-button>
            </div>
            <CreateForm ref="createForm" />
          </a-modal>
          <a-modal
            title={this.$t('page_resource_pool_history')}
            v-model={this.visible.history}
            okText={null}
            cancelText={this.$t('close')}
            onCancel={() => (this.visible.history = false)}
            destroyOnClose={true}
            okButtonProps={{ style: { display: 'none' } }}
            width={1024}
            maskClosable={false}
          >
            <a-spin spinning={this.loading.history}>
              <VersionTable data={this.versionList} onUse={this.handleUse} onSelect={this.handleSelect} />
              {this.loading.history ? (
                ''
              ) : (
                <ComparePanel
                  data={this.versionFileList}
                  current={this.currentVersion}
                  currentIndex={this.currentVersionIndex}
                />
              )}
            </a-spin>
          </a-modal>
        </blank-view>
      </div>
    )
  }
}
